export default __webpack_public_path__ + "static/banner-standards-3-24bfedd47cad81e8c0e4b91ffe5520b1.jpg";